// extracted by mini-css-extract-plugin
export default {"last_nav":"nav_last_nav__nvzlt","drop_menu":"nav_drop_menu__PkjdH"};